export default "__VITE_ASSET__5906af34__"